import { render, staticRenderFns } from "./MemberAssignModal.vue?vue&type=template&id=0c2a2b6e&scoped=true"
import script from "./MemberAssignModal.vue?vue&type=script&lang=ts"
export * from "./MemberAssignModal.vue?vue&type=script&lang=ts"
import style0 from "./MemberAssignModal.vue?vue&type=style&index=0&id=0c2a2b6e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c2a2b6e",
  null
  
)

export default component.exports